import React, { FC } from 'react';

import Link from '@buyside/components/presentation/Link/link';

import styles from './bloombergExcerptStyles.scss';

const BloombergExcerpt: FC = () => (
  <div className={styles.bloombergExcerpt}>
    <div className={styles.bloombergExcerptImageWrapper}>
      <img src="/images/pro/marketing/featured_in_bloomberg.png" alt="" />
    </div>
    <p>
      “Joshua Young <strong>started his hedge fund less than a year ago</strong>. Last month, he
      caught a break when <strong>a university endowment handed him $20 million</strong>,
      quintupling his assets under management.
    </p>
    <br />
    <p>
      <strong>How did an obscure Houston fund</strong> called Bison Interests{' '}
      <strong>land such a big fish</strong>?
    </p>
    <br />
    <p>
      Young, all of 32, <strong>had set up a profile on SumZero</strong>, a website that started out
      as a repository for buy-side research and has more recently morphed into a mashup of LinkedIn
      and Match.com{' '}
      <strong>
        where institutional investors can find up-and-coming fund managers and choose them based on
        the quality of their analysis
      </strong>
      .
    </p>
    <br />
    <p>
      Using SumZero, Young bypassed an old-boy network that prizes relationships, credentials and
      word-of-mouth referrals. The company says it has helped generate hundreds of introductions
      between the more than 12,000 fund managers with SumZero profiles and the 270 institutional
      investors now using the site, which include the family offices of several big tech
      executives.”
    </p>
    <br />
    <Link to="https://www.bloomberg.com/news/articles/2016-02-16/hedge-fund-manager-puts-profile-on-social-media-lures-20-million">
      <cite>
        Wang, Selina. “Hedge Fund Manager Puts Profile on Social Media, Lures $20 Million” <br />
        <em>Bloomberg</em> 16 February 2016.
      </cite>
    </Link>
  </div>
);

export default BloombergExcerpt;
